"use client";

// The buttons of the order popups, in the sizes of the design: 52px high (48px on a phone) so they do not look
// oversized on a phone. Primary: blue border, `width` is the inner width; secondary (Nazaj): grey.
export function PrimaryButton({ children, onClick, loading = false, width = "w-[182px] mobile:w-[146px]" }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      className={`rounded-[10px] bg-gradient-to-b from-[#0A85C2] to-[#123597] p-[2px] shadow-custom-dark-bottom ${loading ? "opacity-60" : ""}`}
    >
      <span className={`flex h-[48px] items-center justify-center rounded-[8px] bg-[#E7EBF0] text-[18px] font-semibold text-[#414B5A] mobile:h-[44px] mobile:text-[16px] ${width}`}>
        {loading ? "…" : children}
      </span>
    </button>
  );
}

export function SecondaryButton({ children, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="h-[52px] w-[92px] rounded-[10px] border border-[#B9C6DD] bg-[#E7EBF0] text-[18px] text-[#7C879A] shadow-custom-dark-bottom mobile:h-[48px] mobile:w-[80px] mobile:text-[16px]"
    >
      {children}
    </button>
  );
}
